<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <div>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="玩家相关" name="first">
                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>玩家查询</span>
                                </div>
                                <template>
                                    <component-query :queryMode="playerQueryMode" @usersData="getUsersData"></component-query>
                                    <!-- 查询用户数据 -->
                                    <!-- id,email,nick,level,status -->
                                    <el-table :data="players" border style="margin-top:10px;width: 100%">
                                        <el-table-column type="expand">
                                            <template slot-scope="scope">
                                                <div class="func-box">
                                                    <el-select v-model="funcSelected" filterable placeholder='请选择' @change="funcOptionChange(funcSelected,scope.row)" style="margin-bottom: 15px;">
                                                        <el-option v-for="item in funcOptions" :key="item.id"
                                                                   :label="item.label" :value="item.id">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 全怪兽 -->
                                                    <div v-if="funcSelected == 1" class="func-box">
                                                        <el-button size="small" @click="unlockMonster(scope.row)">
                                                            确定
                                                        </el-button>
                                                    </div>

                                                    <!-- 发放道具 -->
                                                    <div v-if="funcSelected == 2" class="func-box">
                                                        <el-form label-suffix=":">
                                                            <el-form-item label="操作模式">
                                                                <el-select v-model="propMode" placeholder='请选择模式'>
                                                                    <el-option v-for="item in propTypeOptions" :key="item.id"
                                                                               :label="item.val" :value="item.id">
                                                                    </el-option>
                                                                </el-select>
                                                            </el-form-item>
                                                            <el-form-item label="普通操作" v-if="propMode !==3">
                                                                <el-input v-model="material" type="textarea"></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="覆盖操作" v-if="propMode ===3">
                                                                <el-select v-model="propId" filterable placeholder='请选择道具'>
                                                                    <el-option v-for="item in propConfig" :key="item.id"
                                                                               :label="item.id+'-'+$t(item.name)" :value="item.id">
                                                                    </el-option>
                                                                </el-select>
                                                                <el-input-number v-model="propAmount"></el-input-number>
                                                            </el-form-item>
                                                        </el-form>
                                                        <div slot="footer" class="dialog-footer">
                                                            <el-button @click="propHandler()" type="success">确定</el-button>
                                                        </div>
                                                    </div>

                                                    <!-- 指定地图点 -->
                                                    <div v-if="funcSelected == 3" class="func-box">
                                                        <el-form label-suffix=":" >
                                                            <el-form-item>
                                                                <el-switch v-model="isSelectAllMap" active-text="全地图点" inactive-text="指定地图点"></el-switch>
                                                            </el-form-item>
                                                            <el-form-item v-if="!isSelectAllMap">
                                                                <!--<el-select v-model="mapNodeId" filterable placeholder='请选择'>-->
                                                                    <!--<el-option v-for="item in mapNodeList" :key="item.id"-->
                                                                               <!--:label="(item.id ) +'-' + $t(item.name)" :value="item.id">-->
                                                                    <!--</el-option>-->
                                                                <!--</el-select>-->
                                                                <el-cascader
                                                                    v-model="mapNodeId"
                                                                    :options="mapData"
                                                                    :show-all-levels="false"
                                                                    filterable
                                                                    placeholder='请选择'
                                                                    @change="handleMapNodeChange">
                                                                </el-cascader>
                                                                <el-button size="small" type="danger" @click="unlockMap(scope.row,mapNodeId)">确定</el-button>
                                                            </el-form-item>
                                                            <el-form-item v-if="isSelectAllMap">
                                                                <el-button size="small" type="danger" @click="unlockMap(scope.row,'')">确定</el-button>
                                                            </el-form-item>
                                                        </el-form>
                                                    </div>

                                                    <!-- 指定怪兽等级 -->
                                                    <div v-if="funcSelected == 4" class="func-box">
                                                        <el-form label-suffix=":" >
                                                            <el-form-item label="等级">
                                                                <el-input-number v-model="monsterAssignLv"></el-input-number>
                                                            </el-form-item>
                                                            <el-form-item label="觉醒满状态">
                                                                <el-switch
                                                                    v-model="monsterUpgradeRed"
                                                                    active-text="开启"
                                                                    inactive-text="关闭"
                                                                ></el-switch>
                                                            </el-form-item>
                                                        </el-form>
                                                        <div slot="footer" class="dialog-footer">
                                                            <el-button @click="lvMonster()" type="success">确定</el-button>
                                                        </div>
                                                    </div>

                                                    <!-- 乱入事件 -->
                                                    <div v-if="funcSelected == 5" class="func-box">
                                                        <el-form label-suffix=":">
                                                            <el-form-item label="事件类型">
                                                                <el-select v-model="randomEventForm.current" placeholder='请选择触发事件'>
                                                                    <el-option v-for="item in randomEventCurrent" :key="item.id"
                                                                               :label="item.val" :value="item.id">
                                                                    </el-option>
                                                                </el-select>
                                                            </el-form-item>
                                                            <el-form-item label="对话编号" v-if="randomEventForm.current === 2">
                                                                <el-select v-model="randomEventForm.dialogId" placeholder='请选择触发对话'>
                                                                    <el-option v-for="item in randomEventDialogueGroupConfig" :key="item.id"
                                                                               :label="item.dialog_desc" :value="item.id">
                                                                    </el-option>
                                                                </el-select>
                                                            </el-form-item>
                                                        </el-form>
                                                        <div slot="footer" class="dialog-footer">
                                                            <el-button @click="triggerRandomEvent()" type="success">确定触发</el-button>
                                                        </div>
                                                    </div>

                                                    <!-- 审核-更新帐号类型 -->
                                                    <div v-if="funcSelected == 6" class="func-box">
                                                        <el-form label-suffix=":">
                                                            <el-form-item label="等级">
                                                                <el-select v-model="userType" placeholder='请选择帐号类型'>
                                                                    <el-option v-for="item in userTypeOptions" :key="item.id"
                                                                               :label="item.val" :value="item.id">
                                                                    </el-option>
                                                                </el-select>
                                                            </el-form-item>
                                                        </el-form>
                                                        <div slot="footer" class="dialog-footer">
                                                            <el-button @click="updateUserType()" type="success">确定</el-button>
                                                        </div>
                                                    </div>

                                                    <!-- 清理古战役排阵信息 -->
                                                    <div v-if="funcSelected == 7" class="func-box">
                                                        <el-button size="small"
                                                                   @click="clearAncientCampaign(scope.row)">
                                                            确定
                                                        </el-button>
                                                    </div>

                                                    <!-- 指定极化技能 -->
                                                    <div v-if="funcSelected == 8" class="func-box">
                                                        <el-form label-suffix=":" >
                                                            <el-form-item label="觉醒怪列表">
                                                                <el-select v-model="wakeMonsterId" placeholder='请选择觉醒怪'>
                                                                    <el-option v-for="item in wakeMonsterList" :key="item.id + 10000" :label="(item.id + 10000) +'-' + $t(item.name) + $t('reward_editor.4')"
                                                                               :value="item.id + 10000">

                                                                        <el-image style="width: 30px; height: 30px; float: left"
                                                                                  :src="'./static/item_icon/'+(item.id + 10000)+'.png'"
                                                                                  fit="cover">
                                                                            <div slot="error" class="image-slot">
                                                                                <el-image style="width: 30px; height: 30px; float: left"
                                                                                          :src="'./static/item_icon/0.png'"
                                                                                          fit="cover">
                                                                                </el-image>
                                                                            </div>
                                                                        </el-image>
                                                                        <span style="float: right">{{ $t(item.name) + $t('reward_editor.4') }}</span>
                                                                    </el-option>
                                                                </el-select>
                                                            </el-form-item>
                                                            <el-form-item :label="'指定技能' + (index+1)" v-for="(item,index) in monstersPolarityEntries" :key="item.id">
                                                                <el-select v-model="monstersPolarityEntries[index].id" placeholder='请选择指定技能'>
                                                                    <el-option v-for="item in monstersPolarityList" :key="item.id" :label="(item.id) +'-' + $t(item.name)"
                                                                               :value="item.id">

                                                                        <el-image style="width: 30px; height: 30px; float: left"
                                                                                  :src="'./static/item_icon/'+(item.id)+'.png'"
                                                                                  fit="cover">
                                                                            <div slot="error" class="image-slot">
                                                                                <el-image style="width: 30px; height: 30px; float: left"
                                                                                          :src="'./static/item_icon/0.png'"
                                                                                          fit="cover">
                                                                                </el-image>
                                                                            </div>
                                                                        </el-image>
                                                                        <span style="float: right">{{ $t(item.name)}}</span>
                                                                    </el-option>
                                                                </el-select>

                                                                <el-select v-model="monstersPolarityEntries[index].quality" placeholder='请选择品质'>
                                                                    <el-option v-for="item in plrzAbilityQualityOptions" :key="item.id"
                                                                               :label="item.name" :value="item.id">
                                                                    </el-option>
                                                                </el-select>
                                                            </el-form-item>

                                                        </el-form>
                                                        <div slot="footer" class="dialog-footer">
                                                            <el-button @click="" type="success">确定</el-button>
                                                        </div>
                                                    </div>

                                                    <!-- 全通部落冒险 -->
                                                    <div v-if="funcSelected == 9" class="func-box">
                                                        <el-button size="small" @click="passTribeAdventures(scope.row)">
                                                            确定
                                                        </el-button>
                                                    </div>

                                                    <!-- 填充部落 -->
                                                    <div v-if="funcSelected == 11" class="func-box">
                                                        <el-button size="small" @click="fillTribe(scope.row)">
                                                            确定
                                                        </el-button>
                                                    </div>
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column prop="server" label="大区"></el-table-column>
                                        <el-table-column prop="id" label="用户id"></el-table-column>
                                        <el-table-column prop="nick" label="昵称"></el-table-column>
                                        <el-table-column prop="level" label="等级"></el-table-column>
                                        <el-table-column label="禁言状态">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.silence == 0">正常</span>
                                                <span v-if="scope.row.silence == 1">禁言</span>
                                                <span v-if="scope.row.silence == 2">伪禁言</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="封号状态">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.block == 0">正常</span>
                                                <span v-if="scope.row.block == 1">后台封禁</span>
                                                <span v-if="scope.row.block == 2">系统封禁</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>

                                <el-dialog title='道具操作' :visible.sync="propShowDialog" width="80%"
                                           lock-scroll center>
                                    <el-form label-suffix=":">
                                        <el-form-item label="操作模式">
                                            <el-select v-model="propMode" placeholder='请选择模式'>
                                                <el-option v-for="item in propTypeOptions" :key="item.id"
                                                           :label="item.val" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="普通操作" v-if="propMode !==3">
                                            <el-input v-model="material"></el-input>
                                        </el-form-item>
                                        <el-form-item label="覆盖操作" v-if="propMode ===3">
                                            <el-select v-model="propId" filterable placeholder='请选择道具'>
                                                <el-option v-for="item in propConfig" :key="item.id"
                                                           :label="item.id+'-'+$t(item.name)" :value="item.id">
                                                </el-option>
                                            </el-select>
                                            <el-input-number v-model="propAmount"></el-input-number>
                                        </el-form-item>
                                    </el-form>
                                    <div slot="footer" class="dialog-footer">
                                        <el-button @click="closePropDialog()">取消</el-button>
                                        <el-button @click="propHandler()" type="success">确定</el-button>
                                    </div>
                                </el-dialog>

                                <el-dialog title='指定怪兽等级' :visible.sync="lvMonsterPopupShow" width="80%" lock-scroll
                                           center>
                                    <el-form label-suffix=":" >
                                        <el-form-item label="等级">
                                            <el-input-number v-model="monsterAssignLv"></el-input-number>
                                        </el-form-item>
                                        <el-form-item label="觉醒满状态">
                                            <el-switch
                                                v-model="monsterUpgradeRed"
                                                active-text="开启"
                                                inactive-text="关闭"
                                            ></el-switch>
                                        </el-form-item>
                                    </el-form>
                                    <div slot="footer" class="dialog-footer">
                                        <el-button @click="closeLvMonsterPopup()">取消</el-button>
                                        <el-button @click="lvMonster()" type="success">确定</el-button>
                                    </div>
                                </el-dialog>

                                <el-dialog title='指定极化技能' :visible.sync="polarityPopupShow" width="80%" lock-scroll
                                           center>
                                    <el-form label-suffix=":" >
                                        <el-form-item label="觉醒怪列表">
                                            <el-select v-model="wakeMonsterId" placeholder='请选择觉醒怪'>
                                                <el-option v-for="item in wakeMonsterList" :key="item.id + 10000" :label="(item.id + 10000) +'-' + $t(item.name) + $t('reward_editor.4')"
                                                           :value="item.id + 10000">

                                                    <el-image style="width: 30px; height: 30px; float: left"
                                                              :src="'./static/item_icon/'+(item.id + 10000)+'.png'"
                                                              fit="cover">
                                                        <div slot="error" class="image-slot">
                                                            <el-image style="width: 30px; height: 30px; float: left"
                                                                      :src="'./static/item_icon/0.png'"
                                                                      fit="cover">
                                                            </el-image>
                                                        </div>
                                                    </el-image>
                                                    <span style="float: right">{{ $t(item.name) + $t('reward_editor.4') }}</span>
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item :label="'指定技能' + (index+1)" v-for="(item,index) in monstersPolarityEntries" :key="item.id">
                                            <el-select v-model="monstersPolarityEntries[index].id" placeholder='请选择指定技能'>
                                                <el-option v-for="item in monstersPolarityList" :key="item.id" :label="(item.id) +'-' + $t(item.name) + $t('reward_editor.4')"
                                                           :value="item.id">

                                                    <el-image style="width: 30px; height: 30px; float: left"
                                                              :src="'./static/item_icon/'+(item.id)+'.png'"
                                                              fit="cover">
                                                        <div slot="error" class="image-slot">
                                                            <el-image style="width: 30px; height: 30px; float: left"
                                                                      :src="'./static/item_icon/0.png'"
                                                                      fit="cover">
                                                            </el-image>
                                                        </div>
                                                    </el-image>
                                                    <span style="float: right">{{ $t(item.name) + $t('reward_editor.4') }}</span>
                                                </el-option>
                                            </el-select>

                                            <el-select v-model="monstersPolarityEntries[index].quality" placeholder='请选择品质'>
                                                <el-option v-for="item in plrzAbilityQualityOptions" :key="item.id"
                                                           :label="item.name" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>

                                    </el-form>
                                    <div slot="footer" class="dialog-footer">
                                        <el-button @click="closePolarityPopup()">取消</el-button>
                                        <el-button @click="" type="success">确定</el-button>
                                    </div>
                                </el-dialog>

                                <el-dialog title='更新帐号级别' :visible.sync="updateUserTypePopupShow" width="80%"
                                           lock-scroll center>
                                    <el-form label-suffix=":">
                                        <el-form-item label="等级">
                                            <el-select v-model="userType" placeholder='请选择帐号类型'>
                                                <el-option v-for="item in userTypeOptions" :key="item.id"
                                                           :label="item.val" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-form>
                                    <div slot="footer" class="dialog-footer">
                                        <el-button @click="closeUpdateUserTypePopup()">取消</el-button>
                                        <el-button @click="updateUserType()" type="success">确定</el-button>
                                    </div>
                                </el-dialog>

                                <el-dialog title='乱入事件' :visible.sync="randomEventPopupShow" width="80%" lock-scroll
                                           center>
                                    <el-form label-suffix=":">
                                        <el-form-item label="事件类型">
                                            <el-select v-model="randomEventForm.current" placeholder='请选择触发事件'>
                                                <el-option v-for="item in randomEventCurrent" :key="item.id"
                                                           :label="item.val" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="对话编号" v-if="randomEventForm.current === 2">
                                            <el-select v-model="randomEventForm.dialogId" placeholder='请选择触发对话'>
                                                <el-option v-for="item in randomEventDialogueGroupConfig" :key="item.id"
                                                           :label="item.dialog_desc" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-form>
                                    <div slot="footer" class="dialog-footer">
                                        <el-button @click="closeTriggerRandomEvent()">取消</el-button>
                                        <el-button @click="triggerRandomEvent()" type="success">确定触发</el-button>
                                    </div>
                                </el-dialog>
                            </el-card>
                        </el-tab-pane>
                        <el-tab-pane label="高级账号生成" name="second">
                            <component-server @oneGameServer="getGameValue" :serverMode="'mode__one_game'"></component-server>
                            <el-form label-position="left" label-width="50px" :inline="true">
                                <el-form-item label="sid">
                                    <el-input v-model="buildAccountSid"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="buildAccount">确认</el-button>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="时间重置" name="third">
                            <el-form label-position="left" label-width="50px" :inline="true">
                                <el-form-item label="日期">
                                    <el-date-picker v-model="timeResetYMD" value-format="yyyy-MM-dd" placeholder="任意日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="时间">
                                    <el-time-picker v-model="timeResetHMS" value-format="HH:mm:ss" placeholder="任意时间点">
                                    </el-time-picker>
                                </el-form-item>
                                <el-form-item label="密码">
                                    <el-input v-model="timeResetPwd"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="danger" @click="changeTime()">修改时间(测试服专用)</el-button>
                                </el-form-item>
                            </el-form>
                            <div style="color: red;font-weight: bold;">注：此功能仅用于200服，固定发送 http://192.168.10.200:8080/beasts-evolved-backend</div>
                        </el-tab-pane>

                        <el-tab-pane label="定时器" name="fourth">
                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>
                                        <!--<component-server :serverMode="'mode_one_world'" @oneWorldServer="getWorldValue"></component-server>-->
                                        <component-server :serverMode="'mode_one_world_game'" @worldServer="getWorldValue" @gameServer="getGameServer"></component-server>
                                        <div>部落战 <i class="el-icon-refresh" @click="refreshStatus('get')"></i></div>
                                        <template v-if="tribeStatus > 0">
                                            <el-steps style="margin-top: 12px" :active="tribeStatus"
                                                      finish-status="success">
                                                 <el-step :key="idx" v-for="(stepItem,idx) in warStatus"
                                                          :title="stepItem.title">{{ stepItem.desc }}</el-step>
                                             </el-steps>
                                        </template>
                                    </span>
                                </div>
                                <el-button style="margin-top: 12px" type="danger" @click="refreshStatus('change')"
                                           v-if="statusCode === 1">
                                    <span v-if="tribeStatus === 0">开始部落战</span>
                                    <span v-else>切换到下一阶段</span>
                                </el-button>
                                <div v-if="statusCode === 0">定时器开始运行，不能切换到下个状态（刷新获取最新状态）</div>
                            </el-card>
                            <!-- 竞技场  周一重置,清空所有玩家的竞技场数据-->
                            <!-- 狩猎 清空所有玩家的狩猎积分 -->
                            <!-- 部落繁荣度周发放  -->
                            <!-- 部落赛季清理  -->
                            <!-- 地图集市节点  -->
                            <!-- 世界boss  -->
                            <!-- 强敌  -->
                            <!-- 拍卖所  -->
                            <!-- 觉醒远古怪统计  -->
                            <!-- 暴走旷野  -->
                            <!-- 起源殿  -->
                            <!-- 部落赛季名  -->
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </section>
        </div>
    </el-card>
</template>

<script>
import paginationController from '../../mixins/pagination'
import actionConfirm from '../../mixins/action_confirm'
import commonApi from '../../service/common_api'
import gameApi from '../../service/game_api';
import confApi from '../../service/conf_api'
import componentQuery from '../../components/component_query'
import randomEventCurrentJson from '../../data/config/random_event_current'
import componentServer from '../../components/component_server'
import plrzAbilityQuality from '../../data/config/plrz_ability_quality'

import {
    mapState
} from 'vuex';


export default {
    name: "test_common",
    data() {
        return {
            title: this.$route.meta.title,
            propTypeOptions: [
                {
                    id: 1,
                    val: '发放'
                },
                {
                    id: 2,
                    val: '扣减'
                },
                {
                    id: 3,
                    val: '覆盖'
                }
            ],
            propShowDialog:false,
            material: "0$40001_100000000,0$40002_5000000,0$40003_5000000,0$40004_50000000,0$40024_50000000,0$40025_100000000,0$40026_100000000,3$40005_100000000,3$40007_500000,3$40008_5000000,3$40009_5000000,3$40010_5000000,3$40011_5000000,3$40016_5000000,3$40018_5000000,3$40019_5000000,3$40021_5000000,3$40022_5000000,3$40023_5000000,3$40027_5000000,3$40028_5000000,3$40030_5000000,3$40031_5000000,3$40032_5000000,3$40033_5000000,3$40034_5000000,3$40061_500000,3$40062_500000,3$40063_500000,3$40070_500000,3$40071_500000,3$40072_500000,3$40088_500000,3$40095_500000,3$40096_500000,3$40029_5000000,4$50002_10,4$50003_10,4$50004_10,4$50005_10,4$50006_10,4$50007_30",
            propMode:1,
            propId:"",
            propAmount:0,
            propConfig:[],
            randomEventCurrent: randomEventCurrentJson,
            plrzAbilityQualityOptions: plrzAbilityQuality,
            randomEventDialogueGroupConfig: [],
            randomEventForm: {
                current: 1,
                dialogId: 1
            },
            activeName: 'first',
            select: "",
            serverInfos: [],
            props: "",
            playerQueryMode: ['mode_long_id','mode_short_id','mode_nick','mode_email'],
            postMailData: [],
            players: [],
            queryForm: {},
            timeResetYMD: "",
            timeResetHMS: "",
            timeResetPwd: "",
            tribeStatus: 0,
            statusCode: 0,
            randomEventPopupShow: false,
            lvMonsterPopupShow: false,
            polarityPopupShow: false,
            updateUserTypePopupShow: false,
            monsterAssignLv: 50,
            monsterUpgradeRed:false,
            userType: 1,
            currentRowData: {},


            userTypeOptions: [
                {
                    id: 1,
                    val: '初级'
                },
                {
                    id: 2,
                    val: '中级'
                },
                {
                    id: 3,
                    val: '高级'
                }
            ],
            warStatus: [
                {
                title: '报名期（定时器运行）',
                desc: '',
            }, {
                title: '报名期',
                desc: '',
            }, {
                title: '备战期（定时器运行）',
                desc: '',
            }, {
                title: '备战期',
                desc: '',
            }, {
                title: '开战期（定时器运行）',
                desc: '',
            }, {
                title: '开战期',
                desc: '',
            },],

            worldServer: '',
            gameServer: '',

            wakeMonsterList: [],
            wakeMonsterId: '',

            monstersList: [],
            monstersPolarityList: [],
            monstersPolarityId: '',
            monstersPolarityQuality: '',

            monstersPolarityEntries: [
                {
                    id: '',
                    quality: ''
                },
                {
                    id: '',
                    quality: ''
                },
                {
                    id: '',
                    quality: ''
                },
                {
                    id: '',
                    quality: ''
                },
                {
                    id: '',
                    quality: ''
                },
                {
                    id: '',
                    quality: ''
                },
            ],
            // 功能选项
            funcOptions: [
                {
                    id: 1,
                    label: '全怪兽'
                },
                {
                    id: 2,
                    label: '发放道具'
                },
                {
                    id: 3,
                    label: '指定地图点'
                },
                {
                    id: 4,
                    label: '指定怪兽等级'
                },
                {
                    id: 5,
                    label: '乱入事件'
                },
                {
                    id: 6,
                    label: '审核-更新帐号类型'
                },
                {
                    id: 7,
                    label: '清理古战役排阵信息'
                },
                {
                    id: 8,
                    label: '指定极化技能'
                },
                {
                    id: 9,
                    label: '全通部落冒险'
                },
                {
                    id: 11,
                    label: '填充部落'
                }
            ],
            funcSelected: 1,

            isSelectAllMap: true,

            mapData: [],
            mapNodeList: [],
            mapNodeId: '',

            // 登录服数据
            serverLoginList: [],

            buildAccountSid: '',
            oneGameServer: ''
        }
    },
    created() {
        this.initData();
        this.getReadData();
        this.getNodeAndLoginData();
    },
    mixins: [paginationController, actionConfirm],
    computed: {
        ...mapState({
            token: state => state.user.userInfo.loginToken,
        }),
    },
    methods: {
        getGameValue(uri,serverId) {
            this.oneGameServer = uri;
        },
        // 高级账号生成
        buildAccount() {
          gameApi.buildAccount({
              token: this.token,
              buildAccountBO: {
                  uri: this.oneGameServer,
                  email: this.buildAccountSid
              }
          }).then(res => {
              this.$message({
                  type: 'success',
                  message: "生成成功!"
              })
          })
        },

        getWorldValue(val) {
            console.log(val)
            this.worldServer = val;
        },
        getGameServer(val) {
            console.log(val)
            this.gameServer = val;
        },

        handleClick(tab, event) {
            // console.log(tab, event);
        },
        /**
         * 查询用户数据
         */
        getUsersData(val) {
            this.players = val;
        },
        initData() {
            let self = this;
            let tables = 'random_event_dialogue_group_config,prop_config';
            commonApi.getConfs({
                tables: tables
            }).then(res => {
                self.randomEventDialogueGroupConfig = res.random_event_dialogue_group_config;
                self.propConfig = res.prop_config;
            })
        },
        /**
         * 发放全怪兽
         * @param {Object} rowData
         */
        unlockMonster(rowData) {
            console.log(rowData)
            let self = this;
            gameApi.unlockMonster({
                playerQueryForm: {
                    uri: rowData.uri,
                    serverId: rowData.server,
                    userId: rowData.id
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "解锁完毕"
                })
            })
        },

        lvMonster() {
            let self = this;
            gameApi.lvMonster({
                playerQueryForm: {
                    uri: self.currentRowData.uri,
                    serverId: self.currentRowData.server,
                    userId: self.currentRowData.id,
                    monsterLevel: self.monsterAssignLv,
                    monsterUpgradeRed:self.monsterUpgradeRed
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "解锁完毕"
                })
            })
        },

        handleMapNodeChange(data) {
            this.mapNodeId = data[2];
        },

        /**
         * 解锁全地图
         * @param {Object} rowData
         */
        unlockMap(rowData, nodeId) {
            let self = this;
            gameApi.unlockMap({
                playerQueryForm: {
                    uri: rowData.uri,
                    serverId: rowData.server,
                    userId: rowData.id,
                    nodeId: nodeId
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "解锁完毕"
                })
            })
        },

        // 全通冒险部落
        passTribeAdventures(rowData) {
            let self = this;
            gameApi.passTribeAdventures({
                playerQueryForm: {
                    uri: rowData.uri,
                    serverId: rowData.server,
                    userId: rowData.id,
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "解锁完毕"
                })
            })
        },

        openPropDialog(rowData) {
            this.propShowDialog = true;
            console.log(rowData);
            this.currentRowData = rowData;
        },
        closePropDialog() {
            this.propShowDialog = false;
            this.currentRowData = {};
        },
        propHandler(){
            let self = this;
            gameApi.sendItem({
                playerQueryForm: {
                    uri: self.currentRowData.uri,
                    serverId: self.currentRowData.server,
                    userId: self.currentRowData.id,
                    material: self.material,
                    propMode: self.propMode,
                    propId: self.propId,
                    amount: self.propAmount
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "发送完毕"
                })
            })
        },
        changeTime() {
            let self = this;
            gameApi.changeTime({
                timeForm: {
                    uri: 'http://192.168.10.200:8080/beasts-evolved-backend',
                    timeYMD: self.timeResetYMD,
                    timeHMS: self.timeResetHMS,
                    timePWD: self.timeResetPwd
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "修改完毕"
                })
            })


        },
        refreshStatus(mode) {
            let self = this;
            if (!self.worldServer) {
                self.$message({
                    type: 'error',
                    message: "请选择一个世界服"
                })
                return;
            }

            let opCode = "get";
            if (mode === 'change') {
                if (self.tribeStatus === 0) {
                    //opCode = "";
                } else if (self.tribeStatus === 1) {
                    opCode = "Apply";
                } else if (self.tribeStatus === 2) {
                    opCode = "PrepareTimer";
                } else if (self.tribeStatus === 3) {
                    opCode = "Prepare";
                } else if (self.tribeStatus === 4) {
                    opCode = "ProcessTimer";
                } else if (self.tribeStatus === 5) {
                    opCode = "Process";
                } else if (self.tribeStatus === 6) {
                    opCode = "ApplyTimer";
                }
            }
            gameApi.changeWarStatus({
                warChangeForm: {
                    uri: self.gameServer,
                    worldUri: self.worldServer,
                    opCode: opCode
                },
                token: this.token
            }).then(res => {
                let arr = res.warStatus.split("_");
                self.tribeStatus = parseInt(arr[0]);
                self.statusCode = parseInt(arr[1]);
                self.$message({
                    type: 'success',
                    message: "更新成功，当前世界服-" + self.worldServer
                })
            })
        },
        openRandomEvent(rowData) {
            this.randomEventPopupShow = true;
            console.log(rowData);
            this.currentRowData = rowData;
        },
        closeTriggerRandomEvent() {
            this.randomEventPopupShow = false;
            this.currentRowData = {};
        },
        openLvMonsterPopup(rowData) {
            this.lvMonsterPopupShow = true;
            this.currentRowData = rowData;
        },
        closeLvMonsterPopup() {
            this.lvMonsterPopupShow = false;
            this.currentRowData = {};
        },
        openUpdateUserTypePopup(rowData) {
            this.updateUserTypePopupShow = true;
            this.currentRowData = rowData;
        },
        closeUpdateUserTypePopup() {
            this.updateUserTypePopupShow = false;
            this.currentRowData = {};
        },

        triggerRandomEvent() {
            let self = this;
            gameApi.triggerRandomEvent({
                randomEventForm: {
                    uri: self.currentRowData.uri,
                    serverId: self.currentRowData.server,
                    userId: self.currentRowData.id,
                    current: self.randomEventForm.current,
                    dialogId: self.randomEventForm.dialogId,
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "触发成功"
                })
            })

        },
        updateUserType() {
            let self = this;
            gameApi.updateUserType({
                updateForm: {
                    uri: self.currentRowData.uri,
                    serverId: self.currentRowData.server,
                    userId: self.currentRowData.id,
                    updateType: self.userType
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "更新成功"
                })
            })

        },
        clearAncientCampaign(rowData){
            console.log(rowData)
            let self = this;
            gameApi.clearAncientCampaign({
                playerQueryForm: {
                    uri: rowData.uri,
                    serverId: rowData.server,
                    userId: rowData.id
                },
                token: this.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "清理完毕"
                })
            })
        },

        openPolarityPopup(rowData) {
            // this.polarityPopupShow = true;

            var playMonsters = [];

            gameApi.findMonstersByPlayerId({
                playerQueryForm: {
                    uri: rowData.uri,
                    serverId: rowData.server,
                    userId: rowData.id,
                    email: '',
                    nick: ''
                },
                token: this.token
            }).then(res => {
                playMonsters = res.content.monsters;

                playMonsters.forEach(playMonstersItem => {
                    this.monstersList.forEach(monstersListItem => {
                        if (playMonstersItem.identifier == monstersListItem.id && monstersListItem.quality == 4) {
                            this.wakeMonsterList.push(monstersListItem)
                        }
                    })
                })
            })

        },

        closePolarityPopup() {
            this.polarityPopupShow = false;
        },

        getReadData() {
            confApi.getReadData({
                token: this.token,
                tableName: 'monster_config'
            }).then(res => {
                this.monstersList = res;
            })

            confApi.getReadData({
                token: this.token,
                tableName: 'monster_polarity_config'
            }).then(res => {
                this.monstersPolarityList = res;
            })

            confApi.getReadData({
                token: this.token,
                tableName: 'map_node'
            }).then(res => {
                this.mapNodeList = res;
                let mapData = [];
                let floorSet = [];
                let typeSet = [];
                for (let i = 0; i < this.mapNodeList.length - 1; i++) {
                    let item = this.mapNodeList[i];
                    item.label = (item.id) +'-' + this.$t(item.name);
                    item.value = item.id
                    let floor = item.floor;
                    let type = item.type;
                    if (floorSet.indexOf(floor) === -1) {
                        floorSet.push(floor);
                    }
                    if (typeSet.indexOf(type) === -1) {
                        typeSet.push(type);
                    }
                }

                for (let i = 0; i < floorSet.length; i++) {
                    let currentFloor = floorSet[i];
                    let mapTypeChildren = [];
                    for (let j = 0; j < typeSet.length; j++) {
                        mapTypeChildren.push({
                            label: 'type'+typeSet[j],
                            value: typeSet[j],
                            children: []
                        })
                    }
                    mapData.push({
                        label: '第'+currentFloor +'层',
                        value: currentFloor,
                        children: mapTypeChildren
                    })

                }

                for (let i = 0; i < this.mapNodeList.length; i++) {
                    let item = this.mapNodeList[i];
                    item.label = (item.id) +'-' + this.$t(item.name);
                    item.value = item.id
                    let floor = item.floor;
                    for (const info of mapData){
                        if (info.value == floor){
                            for (const typeInfo of info.children){
                                if (typeInfo.value == item.type){
                                    typeInfo.children.push(item);
                                    break;
                                }
                            }
                            break;
                        }
                    }
                }
                console.log(mapData);
                this.mapData = mapData;
            })
        },

        funcOptionChange(funcSelected,rowData) {
            this.currentRowData = rowData;
            if (funcSelected == 8) {
                this.openPolarityPopup(rowData);
            }
        },

        // 填充部落
        fillTribe(rowData) {
            let self = this;
            var loginIp = self.serverLoginList[0].server_url;
            gameApi.fillTribe({
                playerQueryForm: {
                    uri: rowData.uri,
                    serverId: rowData.server,
                    userId: rowData.id,
                    loginIp: loginIp
                },
                token: self.token
            }).then(res => {
                self.$message({
                    type: 'success',
                    message: "填充完毕"
                })
            })
        },

        // 获取登录服和战斗服数据
        getNodeAndLoginData() {
            let self = this;
            confApi.getReadData({
                token: self.token,
                tableName: 'yunwei_server_config'
            }).then(res => {
                res.forEach(item => {
                    if (item.serverType == 'login') {
                        this.serverLoginList.push(item)
                    }
                })
            })
        },

    },
    components: {
        componentQuery,
        componentServer
    }
}
</script>

<style scoped>

</style>

<style lang="less">
    .func-box {
        border: 1px solid #ebeef5;
        padding: 15px 15px;
        box-sizing: border-box;
        margin-bottom: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/test_tools/test_common.vue